/**
 * Kurulum bekleniyor — ayar yetkisi OLMAYAN kullanıcının kilit ekranı.
 *
 * Kurulum tamamlanmadan panel GEZİNMESİ kilitlenir (kullanıcı kuralı). Okuma API'leri izinle açık kalır;
 * fatura kesmeyi asıl engelleyen motorun kurulum kapısıdır (settings/setup.ts).
 *
 * Yetkisi olan kullanıcı Kurulum ekranına yönlendirilir ve eksiği düzeltir;
 * yetkisi olmayan kişi ise ne düzeltebilir ne de eksiğin ne olduğunu görmeli
 * (ayar ayrıntısı `ayar.goruntule` ister). Ona söylenecek tek şey: sistem
 * henüz hazır değil, yöneticiye haber ver.
 *
 * Eksiğin ne olduğu bilerek yazılmıyor — "Veriban şifresi girilmedi" gibi
 * bir cümle, ayar yetkisi olmayan birine sistemin iç yapısını anlatır.
 */

import { Hourglass, LogOut } from 'lucide-react';
import { Kart } from '../components/ui/Kart';
import { Dugme } from '../components/ui/Dugme';
import { BosDurum } from '../components/Durumlar';
import { useOturum } from '../oturum';

export function KurulumBekleniyor() {
  const { kullanici, cikisYap } = useOturum();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--ground)] p-4">
      <div className="w-full max-w-lg">
        <Kart>
          <BosDurum
            ikon={<Hourglass size={32} strokeWidth={1.5} />}
            baslik="Sistem kurulumu henüz tamamlanmadı"
            aciklama={
              'Fatura sistemi kullanıma açılmadan önce yöneticinin kurulum adımlarını ' +
              'bitirmesi gerekiyor. Bu süre içinde panel kapalıdır; hiçbir sipariş ' +
              'kaybolmaz, faturalar kurulum bitince kesilir. ' +
              `Giriş yapan hesap: ${kullanici?.email ?? ''}.`
            }
            eylem={
              <Dugme gorunum="ikincil" ikon={<LogOut size={15} />} onClick={() => void cikisYap()}>
                Çıkış yap
              </Dugme>
            }
          />
        </Kart>
      </div>
    </div>
  );
}
